import { create } from 'zustand'

const useSessionStore = create((set, get) => ({
  sessionId: null,
  verifLink: null,
  selectedType: null,
  selectedMethod: null,
  capturedFiles: [],
  lastCapturedFileId: null,
  transferUrl: null,
  createdAt: null,
  phoneConnected: false,
  webcamActive: false,

  setVerifLink: (link) => set({ verifLink: link }),

  setSelectedType: (type) => set({ selectedType: type }),

  setSelectedMethod: (method) => set({ selectedMethod: method }),

  addCapturedFile: (file) =>
    set((state) => ({
      capturedFiles: [...state.capturedFiles, file],
      lastCapturedFileId: file.id,
      sessionId: state.sessionId || crypto.randomUUID(),
      createdAt: state.createdAt || Date.now(),
    })),

  replaceCapturedFile: (id, file) =>
    set((state) => ({
      capturedFiles: state.capturedFiles.map((f) =>
        f.id === id ? file : f
      ),
      lastCapturedFileId: file.id,
    })),

  removeCapturedFile: (id) =>
    set((state) => ({
      capturedFiles: state.capturedFiles.filter((f) => f.id !== id),
    })),

  updateCapturedFile: (id, updates) =>
    set((state) => ({
      capturedFiles: state.capturedFiles.map((f) =>
        f.id === id ? { ...f, ...updates } : f
      ),
    })),

  setTransferUrl: (url) => set({ transferUrl: url }),

  setPhoneConnected: (val) => set({ phoneConnected: val }),

  setWebcamActive: (val) => set({ webcamActive: val }),

  resetSession: () =>
    set({
      sessionId: null,
      verifLink: null,
      selectedType: null,
      selectedMethod: null,
      capturedFiles: [],
      lastCapturedFileId: null,
      transferUrl: null,
      createdAt: null,
      phoneConnected: false,
      webcamActive: false,
    }),
}))

export default useSessionStore
